// https://jsperf.com/startdust-callable
var callable = function (possibleFunction) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return typeof possibleFunction === 'function' ? possibleFunction.apply(void 0, args) : possibleFunction;
}; };
export default callable;
